<template>
	<LazyHydrate when-visible>
		<layoutSection>
			<div class="p-16 tablet:p-0 space-y-56">
				<div class="flex flex-col tablet:flex-row tablet:flex-wrap space-y-32">
					<header class="tablet:w-8/12">
						<slot name="title">
							<h2 class="font-bold text-32 tablet:text-40 desktop:text-48">Check out our deals</h2>
						</slot>
					</header>

					<div class="tablet:w-8/12 ">
						<slot name="intro">
						</slot>
					</div>
				</div>

				<div class="grid grid-cols-1 tablet:grid-cols-2 tabletWide:grid-cols-4 tabletWide:gap-16 gap-48 tablet:gap-x-16">
					<a href="/deals/" class="group w-full relative rounded-6 shadow-sm hover:shadow transition-shadow">
						<div class="absolute -mt-32 text-white bg-goPinkDark flex flex-col items-center justify-center rounded-oval text-center w-72 h-72 shadow-sm group-hover:shadow transition-shadow right-0 mr-16 tablet:mr-0 tablet:ml-16 tablet:right-auto">
							<span class="text-12 -mb-8">From</span>
							<span class="text-24"><span class="font-bold">10</span>%</span>
							<span class="text-14 -mt-8">off</span>
						</div>
						<div class="bg-goPinkBrighter rounded-6 border border-goPink/5 overflow-hidden h-full">
							<div class="h-full flex flex-col p-16 space-y-8 tablet:pt-56">
								<p class="text-24 text-goPink font-bold">Hot Deals</p>
								<p class="flex-1 text-14 ">
									Secure the best deals for your car rental in New Zealand. From discounted bookings across our most popular cars to relocation deals for one-way trips. Discover how you can save with GO.
								</p>
								<hr class="border-goPink/20">
								<div class="font-bold text-goPink group-hover:text-goPinkDark space-x-12 flex items-center">
									<span>See all deals</span>
									<svg-icon name="arrow-forward" class="iconSize-20 opacity-50 group-hover:opacity-90 translate-y-2 transition-all translate-x-0 group-hover:translate-x-1" />
								</div>
							</div>
						</div>
					</a>

					<button type="button" @click="openSubscribeModal" class="group w-full relative rounded-6 shadow-sm hover:shadow transition-shadow text-left">
						<div class="absolute -mt-32 text-white bg-goPinkDark flex flex-col items-center justify-center rounded-oval text-center w-72 h-72 shadow-sm group-hover:shadow transition-shadow right-0 mr-16 tablet:mr-0 tablet:ml-16 tablet:right-auto">
							<span class="text-24"><span class="font-bold">10</span>%</span>
							<span class="text-14 -mt-8">off</span>
						</div>
						<div class="bg-goPinkBrighter rounded-6 border border-goPink/5 overflow-hidden h-full">
							<div class="h-full flex flex-col p-16 space-y-8 tablet:pt-56">
								<p class="text-24 text-goPink font-bold">Join Our Newsletter</p>
								<p class="flex-1 text-14 ">
									Sign up to our GO newsletter and save 10% off your next adventure. Not only that, we will send you exclusive car rental deals, road trip inspiration and travel tips.
								</p>
								<hr class="border-goPink/20">
								<div class="font-bold text-goPink group-hover:text-goPinkDark space-x-12 flex items-center">
									<span>Subscribe</span>
									<svg-icon name="arrow-forward" class="iconSize-20 opacity-50 group-hover:opacity-90 translate-y-2 transition-all translate-x-0 group-hover:translate-x-1" />
								</div>
							</div>
						</div>
					</button>

					<a href="/deals/promotion/?code=aamember" class="group w-full relative rounded-6 shadow-sm hover:shadow transition-shadow">
						<div class="absolute -mt-32 text-white bg-goPinkDark flex flex-col items-center justify-center rounded-oval text-center w-72 h-72 shadow-sm group-hover:shadow transition-shadow right-0 mr-16 tablet:mr-0 tablet:ml-16 tablet:right-auto">
							<span class="text-24"><span class="font-bold">15</span>%</span>
							<span class="text-14 -mt-8">off</span>
						</div>
						<div class="bg-goPinkBrighter rounded-6 border border-goPink/5 overflow-hidden h-full">
							<div class="h-full flex flex-col p-16 space-y-8 tablet:pt-56">
								<p class="text-24 text-goPink font-bold">AA Member Discount</p>
								<p class="flex-1 text-14 ">
									AA Members get an exclusive 15% off the daily rate from every GO Rentals car booking. <br> Book online or call us with your membership number to redeem this offer.
								</p>
								<hr class="border-goPink/20">
								<div class="font-bold text-goPink group-hover:text-goPinkDark space-x-12 flex items-center">
									<span>Get the discount</span>
									<svg-icon name="arrow-forward" class="iconSize-20 opacity-50 group-hover:opacity-90 translate-y-2 transition-all translate-x-0 group-hover:translate-x-1" />
								</div>
							</div>
						</div>
					</a>

					<a href="/go-snap-happy/" class="group w-full relative rounded-6 shadow-sm hover:shadow transition-shadow">
						<div class="absolute -mt-32 text-white bg-goPinkDark flex flex-col items-center justify-center rounded-oval text-center w-72 h-72 shadow-sm group-hover:shadow transition-shadow right-0 mr-16 tablet:mr-0 tablet:ml-16 tablet:right-auto">
							<span class="text-12 -mb-8">Win up to</span>
							<span class="text-24">$<span class="font-bold">500</span></span>
						</div>
						<div class="bg-goPinkBrighter rounded-6 border border-goPink/5 overflow-hidden h-full">
							<div class="h-full flex flex-col p-16 space-y-8 tablet:pt-56">
								<p class="text-24 text-goPink font-bold">Snap Happy</p>
								<p class="flex-1 text-14 ">
									Your travel memories matter to us! <br>
									Snap a picture of your adventure around New Zealand, and be in to win up to $500 of the cost of your rental back.
								</p>
								<hr class="border-goPink/20">
								<div class="font-bold text-goPink group-hover:text-goPinkDark space-x-12 flex items-center">
									<span>GO Snap Happy</span>
									<svg-icon name="arrow-forward" class="iconSize-20 opacity-50 group-hover:opacity-90 translate-y-2 transition-all translate-x-0 group-hover:translate-x-1" />
								</div>
							</div>
						</div>
					</a>
				</div>
			</div>
		</layoutSection>
	</LazyHydrate>
</template>

<script>
import layoutSection from '~/components/layoutSection.vue';

export default {
	components: {
		layoutSection,
	},
	methods: {
		async openSubscribeModal() {
			const { default: subscribeModal } = await import("~/components/modals/subscribe.vue")
			this.$modalService.show(subscribeModal)
		},
	},
};
</script>
